import styled from 'styled-components';

export const WinProbabilityWrapper = styled.div`
  font-family: var(--gameday-primary-font);
  width: 100%;
  height: auto;
  font-size: 14px;
  font-weight: 500;
  color: var(--gameday-primary-color);
  margin-top: 8px;
  line-height: 20px !important;
  
  span {
    margin-right: 3px;

    &.plus {
      color: var(--gameday-green);
      margin-right: 0px;
      &::before {
          content: '+';
          display: inline;
      }
    }
  
    &.minus {
      color: var(--gameday-red);
      margin-right: 0px;
      &::before {
          content: '-';
          display: inline;
      }
    }

  }

`;

export const PercentageWrapper = styled.span`
  white-space: nowrap;
  color: var(--gameday-primary-font-color);
`;

export const WinProbabilityBoldWrapper = styled.span`
  font-weight: 700;
  display: inline-block;
`;